module.exports = __webpack_public_path__ + "img/printer.7bd71512.svg";